import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAuthContext } from '../../hooks/agencyAuthHook'
import toast from 'react-hot-toast'
import ProfileHook from '../../hooks/ProfileHook';
import file_icon from '../../assets/images/files-icon.jpg'
import { Avatar, Dialog } from '@mui/material';

export default function Profile() {
  const { getAgencyProfile } = ProfileHook();
  const { agency } = useAuthContext()
  const apiUrl = process.env.REACT_APP_API_URL;
  const profile = useSelector((state) => state.profile.profile);
  const collapsed = useSelector((state) => state.collapsed.collapsed);
  const [activeStatus, setActiveStatus] = useState(0);
  const [formData, setFormData] = useState({
    name: '',
    profile_pic: '',
    email: '',
    phone: '',
    additional_phone: '',
    whatsapp_phone: '',
    address: '',
    reg_no: '',
    province:'',
    district:'',
    munazam_name:'',
    documents: [],
  });

  const provinces={
    "Pakistan": {
      "Khyber Pakhtunkhwa (KPK)": [
        "Abbottabad",
        "Bajaur",
        "Bannu",
        "Battagram",
        "Buner",
        "Charsadda",
        "Chitral",
        "Dera Ismail Khan",
        "Hangu",
        "Haripur",
        "Karak",
        "Kohat",
        "Kohistan",
        "Kurram",
        "Lakki Marwat",
        "Lower Dir",
        "Lower Kohistan",
        "Malakand",
        "Mansehra",
        "Mardan",
        "Mohmand",
        "North Waziristan",
        "Nowshera",
        "Orakzai",
        "Peshawar",
        "Shangla",
        "South Waziristan",
        "Swabi",
        "Swat",
        "Tank",
        "Torghar",
        "Upper Dir",
        "Upper Kohistan"
      ],
      "Punjab": [
        "Attock",
        "Bahawalnagar",
        "Bahawalpur",
        "Bhakkar",
        "Chakwal",
        "Chiniot",
        "Dera Ghazi Khan",
        "Faisalabad",
        "Gujranwala",
        "Gujrat",
        "Hafizabad",
        "Jhang",
        "Jehlum",
        "Kasur",
        "Khanewal",
        "Khushab",
        "Lahore",
        "Layyah",
        "Lodhran",
        "Mandi Bahauddin",
        "Mianwali",
        "Multan",
        "Muzaffargarh",
        "Nankana Sahib",
        "Narowal",
        "Okara",
        "Pakpattan",
        "Rahim Yar Khan",
        "Rajanpur",
        "Rawalpindi",
        "Sahiwal",
        "Sargodha",
        "Sheikhupura",
        "Sialkot",
        "Toba Tek Singh",
        "Vehari"
      ],
      "Sindh": [
        "Badin",
        "Dadu",
        "Ghotki",
        "Hyderabad",
        "Jacobabad",
        "Jamshoro",
        "Karachi",
        "Kashmore",
        "Khairpur",
        "Korangi",
        "Larkana",
        "Malir",
        "Matiari",
        "Mirpurkhas",
        "Naushahro Feroze",
        "Qambar Shahdadkot",
        "Sanghar",
        "Shaheed Benazirabad",
        "Shikarpur",
        "Sujawal",
        "Tharparkar",
        "Thatta",
        "Umerkot"
      ],
      "Balochistan": [
        "Awaran",
        "Barkhan",
        "Bolan",
        "Chagai",
        "Dera Bugti",
        "Gwadar",
        "Harnai",
        "Jafarabad",
        "Jhal Magsi",
        "Kalat",
        "Kech",
        "Kharan",
        "Khuzdar",
        "Killa Abdullah",
        "Killa Saifullah",
        "Kohlu",
        "Lasbela",
        "Loralai",
        "Mastung",
        "Musakhel",
        "Naseerabad",
        "Nushki",
        "Panjgur",
        "Pishin",
        "Quetta",
        "Sherani",
        "Sibi",
        "Sohbatpur",
        "Washuk",
        "Zhob",
        "Ziarat"
      ],
      "Islamabad Capital Territory": [
        "Islamabad"
      ],
      "Gilgit-Baltistan": [
        "Astore",
        "Baltistan Division",
        "Diamer",
        "Ghanche",
        "Gilgit",
        "Hunza",
        "Kharmang",
        "Nagar",
        "Shigar",
        "Skardu"
      ],
      "Azad Kashmir": [
        "Bagh",
        "Bhimber",
        "Hattian Bala",
        "Kotli",
        "Mirpur",
        "Muzaffarabad",
        "Neelum",
        "Poonch",
        "Sudhanoti"
      ]
    }
  }
  

  const handleProvinceChange = (event) => {
    setFormData({
      ...formData,
      province: event.target.value,
      district: "" // Reset district when province changes
    });
  };

  const handleDistrictChange = (event) => {
    setFormData({
      ...formData,
      district: event.target.value
    });
  };

  const provinceOptions = Object.keys(provinces["Pakistan"]);
  const districtOptions = formData.province
    ? provinces["Pakistan"][formData.province]
    : [];

  // Handle image selection
  const handleImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert('File size exceeds the 5MB limit. Please select a smaller file.');
      } else {
        TransformFile(file);
      }
    }
  };

  // Transform file to base64
  const TransformFile = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setFormData((prevData) => ({
        ...prevData,
        profile_pic: reader.result,
      }));
    };
  };

  useEffect(() => {
    document.title = 'Agency Profile'
    getAgencyProfile();
  }, [])
  // Update formData when profile changes, but preserve other fields
  useEffect(() => {

    if (profile) {
      setFormData((prevData) => ({
        ...prevData,
        name: profile.name || prevData.name,
        profile_pic: profile.profile_pic || prevData.profile_pic,
        email: profile.email || prevData.email,
        phone: profile.phone || prevData.phone,
        additional_phone: profile.additional_phone || prevData.additional_phone,
        whatsapp_phone: profile.whatsapp_phone || prevData.whatsapp_phone,
        address: profile.address || prevData.address,
        reg_no: profile.reg_no || prevData.reg_no,
        province: profile.province || prevData.province,
        district: profile.district || prevData.district,
        munazam_name: profile.munazam_name || prevData.munazam_name,
        documents: profile.documents || prevData.documents,
      }));
    }
  }, [profile]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // Updating Profile
  const updateProfile = async (_) => {
    toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          const response = await fetch(`${apiUrl}/api/agencies/update/profile`, {
            method: "PUT",
            headers: {
              'Authorization': `Bearer ${agency.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ data: formData }),
          });
          const json = await response.json();

          if (response.ok) {
            resolve(json.message);
            getAgencyProfile()
          }
          if (!response.ok) {
            reject(new Error(json.message || "Failed to update.")); // Use actual API message for error

          }
        } catch (error) {

          reject(new Error(error.message || "Unexpected error occurred.")); // Handle unexpected errors
        } finally {

        }
      }),
      {
        loading: "Updating...",
        success: (message) => <b>{message || "Update successfully!"}</b>, // Use dynamic message for success
        error: (error) => <b>{error.message || "Failed to update."}</b>, // Use dynamic message for error
      }
    );
  }

  // Uploading Files
  const documents = profile && profile.documents
  const [file_name, setfile_name] = useState('');
  const [file_name2, setfile_name2] = useState('');
  const [isOtherFileName, setIsOtherFileName] = useState(false);
  const [file_url, setfile_url] = useState('');
  const [selected_file_name, setselected_file_name] = useState('');
  const [selected_file, setSelectedFile] = useState(null);
  
  const [newDoc, setNewDoc] = useState(false);
  const [editedDocId, setEditedDocId] = useState('');
  
  useEffect(() => {
    if (file_name === 'Other') {
      setIsOtherFileName(true);
    } else {
      setIsOtherFileName(false);
    }
  }, [file_name]);
  
  const handleCancel = () => {
    setNewDoc(false);
    setEditedDocId('');
    setfile_name('');
    setfile_name2('');
    setfile_url('');
    setselected_file_name('');
  };
  
  const handleEditDoc = (data) => {
    setNewDoc(true);
    setEditedDocId(data._id);
    
    const fileName = data.file_name.trim().toLowerCase();
    
    if (fileName !== 'recognition letter' && fileName !== 'secp certificate' && fileName !== 'munazim card') {
      setIsOtherFileName(true);
      setfile_name2(data.file_name); // set the custom name in file_name2
      setfile_name("Other"); // this will be set to 'Other' if the condition is met
    } else {
      setfile_name(data.file_name); // use the pre-defined names
    }
    
    setfile_url(data.file_url);
    setselected_file_name(data.selected_file_name);
  };

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validExtensions = [
        'application/pdf', // PDF
        'image/jpeg', // JPG
        'image/png', // PNG
      ]

      // Check for valid file type
      if (!validExtensions.includes(file.type)) {
        alert('Invalid file type. Please upload a PDF or Word document.');
        return;
      }

      // Check file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('File size exceeds the 5MB limit. Please select a smaller file.');
        return;
      }

      setselected_file_name(file.name); // Store selected file name
      setfile_url(URL.createObjectURL(file)); // Create a URL for file preview
      setSelectedFile(file); // Store the actual file
    }
  };

  const clearFile = () => {
    setfile_url('');
    setselected_file_name('');
  };

  // Upload File
  const uploadFile = async (e) => {
    e.preventDefault();

    // Ensure file is selected before submitting
    if (!selected_file) {
      alert('Please select a file to upload.');
      return;
    }

    const data = new FormData();
    data.append('file', selected_file); // Append the actual file
    data.append('file_name',isOtherFileName?file_name2: file_name); // Append file name
    data.append('selected_file_name', selected_file_name); // Append selected file name

    toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          const response = await fetch(`${apiUrl}/api/agencies/documents/add`, {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${agency.token}`,
            },
            body: data,
          });
          const json = await response.json();

          if (response.ok) {
            resolve(json.message);
            handleCancel();
            getAgencyProfile();
          } else {
            reject(new Error(json.message || 'Failed to upload.'));
          }
        } catch (error) {
          reject(new Error(error.message || 'Unexpected error occurred.'));
        }
      }),
      {
        loading: 'Saving...',
        success: (message) => <b>{message || 'Saved successfully!'}</b>,
        error: (error) => <b>{error.message || 'Failed to upload.'}</b>,
      }
    );
  };

  // update File
  const updateFile = async (e) => {
    e.preventDefault()
    toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          const response = await fetch(`${apiUrl}/api/agencies/documents/update`, {
            method: "PUT",
            headers: {
              'Authorization': `Bearer ${agency.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ data: { _id: editedDocId, file_name:isOtherFileName?file_name2: file_name, selected_file_name, file_url } }),
          });
          const json = await response.json();

          if (response.ok) {
            resolve(json.message);
            handleCancel()
            getAgencyProfile()
          }
          if (!response.ok) {
            reject(new Error(json.message || "Failed to save.")); // Use actual API message for error

          }
        } catch (error) {

          reject(new Error(error.message || "Unexpected error occurred.")); // Handle unexpected errors
        } finally {

        }
      }),
      {
        loading: "Saving...",
        success: (message) => <b>{message || "Saved successfully!"}</b>, // Use dynamic message for success
        error: (error) => <b>{error.message || "Failed to upload."}</b>, // Use dynamic message for error
      }
    );
  }

  const deleteFile = async (_id) => {
    if (window.confirm('Are you sure you want to delete?')) {

      try {
        const response = await fetch(`${apiUrl}/api/agencies/documents/delete`, {
          method: "DELETE",
          headers: {
            'Authorization': `Bearer ${agency.token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ _id })
        })

        const json = await response.json()
        if (response.ok) {
          toast.success(json.message)
          handleCancel()
          getAgencyProfile()
        }
        if (!response.ok) {
          toast.error(json.message)

        }
      } catch (error) {
        toast.error(error.message)

      }
    }
  }


  // Uploading Files
  const focal_persons = profile && profile.focal_persons
  const [newFocalPerson, setNewFocalPerson] = useState(false)
  const [name, setname] = useState('')
  const [email, setemail] = useState('')
  const [phone, setphone] = useState('')
  const [city, setcity] = useState('')
  const [editedPersonId, setEditedPersonId] = useState('')


  const handleEdiePerson = (data) => {
    setNewFocalPerson(true)
    setEditedPersonId(data._id)
    setname(data.name)
    setemail(data.email)
    setphone(data.phone)
    setcity(data.city)
  }

  const handleCoseNewPerson = () => {
    setNewFocalPerson(false)
    setEditedPersonId('')
    setname('')
    setemail('')
    setphone('')
    setcity('')
  }

  const [loading1, setLoading1] = useState(false)

  // add a new focal person
  const addFocalPerson = async (e) => {
    e.preventDefault()
    setLoading1(true)
    toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          const response = await fetch(`${apiUrl}/api/focalpersons/add`, {
            method: "POST",
            headers: {
              'Authorization': `Bearer ${agency.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ data: { name, email, phone, city } }),
          });
          const json = await response.json();

          if (response.ok) {
            resolve(json.message);
            setLoading1(false)
            getAgencyProfile()
            handleCoseNewPerson()
          }
          if (!response.ok) {
            reject(new Error(json.message || "Failed to save.")); // Use actual API message for error
            setLoading1(false)

          }
        } catch (error) {
          setLoading1(false)
          reject(new Error(error.message || "Unexpected error occurred.")); // Handle unexpected errors
        } finally {
          setLoading1(false)

        }
      }),
      {
        loading: "Saving...",
        success: (message) => <b>{message || "Saved successfully!"}</b>, // Use dynamic message for success
        error: (error) => <b>{error.message || "Failed to save."}</b>, // Use dynamic message for error
      }
    );
  }

  // add a new focal person
  const updateFocalPerson = async (e) => {
    e.preventDefault()
    setLoading1(true)
    toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          const response = await fetch(`${apiUrl}/api/focalpersons/update`, {
            method: "PUT",
            headers: {
              'Authorization': `Bearer ${agency.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ data: { _id: editedPersonId, name, email, phone, city } }),
          });
          const json = await response.json();

          if (response.ok) {
            resolve(json.message);
            setLoading1(false)
            getAgencyProfile()
            handleCoseNewPerson()
          }
          if (!response.ok) {
            reject(new Error(json.message || "Failed to save.")); // Use actual API message for error
            setLoading1(false)

          }
        } catch (error) {
          setLoading1(false)
          reject(new Error(error.message || "Unexpected error occurred.")); // Handle unexpected errors
        } finally {
          setLoading1(false)

        }
      }),
      {
        loading: "Saving...",
        success: (message) => <b>{message || "Saved successfully!"}</b>, // Use dynamic message for success
        error: (error) => <b>{error.message || "Failed to save."}</b>, // Use dynamic message for error
      }
    );
  }


  const deleteFocalPerson = async (_id) => {
    if (window.confirm('Are you sure you want to delete?')) {

      try {
        const response = await fetch(`${apiUrl}/api/focalpersons/delete`, {
          method: "DELETE",
          headers: {
            'Authorization': `Bearer ${agency.token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ _id })
        })

        const json = await response.json()
        if (response.ok) {
          toast.success(json.message)
          handleCancel()
          getAgencyProfile()
        }
        if (!response.ok) {
          toast.error(json.message)

        }
      } catch (error) {
        toast.error(error.message)

      }
    }
  }

  // Managing Social Links
  const social_links = profile && profile.social_links
  const [platform, setplatform] = useState('')
  const [platform1, setplatform1] = useState('')
  const [isOtherPlatform, setIsOtherPlatform] = useState(false);

  const [link, setlink] = useState('')
  const [newLink, setNewLink] = useState(false)

  useEffect(() => {
    if (platform === 'Other') {
      setIsOtherPlatform(true);
    } else {
      setIsOtherPlatform(false);
    }
  }, [platform]);

  const hanldeCancelNewLink = () => {
    setNewLink(false)
    setplatform('')
    setplatform1('')
    setlink('')
  }

  // adding a new link
  const addSocialLink = async (e) => {
    e.preventDefault()
    setLoading1(true)
    toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          const response = await fetch(`${apiUrl}/api/agencies/social/add`, {
            method: "POST",
            headers: {
              'Authorization': `Bearer ${agency.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ data: { platform:isOtherPlatform?platform1:platform, link } }),
          });
          const json = await response.json();

          if (response.ok) {
            resolve(json.message);
            setLoading1(false)
            getAgencyProfile()
            hanldeCancelNewLink()
          }
          if (!response.ok) {
            reject(new Error(json.message || "Failed to save.")); // Use actual API message for error
            setLoading1(false)

          }
        } catch (error) {
          setLoading1(false)
          reject(new Error(error.message || "Unexpected error occurred.")); // Handle unexpected errors
        } finally {
          setLoading1(false)

        }
      }),
      {
        loading: "Saving...",
        success: (message) => <b>{message || "Saved successfully!"}</b>, // Use dynamic message for success
        error: (error) => <b>{error.message || "Failed to save."}</b>, // Use dynamic message for error
      }
    );
  }


  const deleteSocialLink = async (_id) => {
    if (window.confirm('Are you sure you want to delete?')) {

      try {
        const response = await fetch(`${apiUrl}/api/agencies/social/delete`, {
          method: "DELETE",
          headers: {
            'Authorization': `Bearer ${agency.token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ _id })
        })

        const json = await response.json()
        if (response.ok) {
          toast.success(json.message)
          handleCancel()
          getAgencyProfile()
        }
        if (!response.ok) {
          toast.error(json.message)

        }
      } catch (error) {
        toast.error(error.message)

      }
    }
  }

  return (
    <div className={`${collapsed ? 'collapsed mt-5' : 'main mt-5'}`}>
      <div className="container-fluid bg-none my-0 mt-4">
        <div className="row px-2 mt-5 pt-4 packages">
          <div className="col-md-12 data_table p-2 py-auto my-auto header_section">
            <div className="profile_setting border m-2">
              <div className="top_section py-5 m-0" />
              <div className="bottom_section m-0">
                <div className="justify-content-between px-2 mb-2">
                  <div className="d-flex align-items-center">
                    <div className="profile_pic">

                      <img src={formData.profile_pic} alt="" />

                    </div>
                    <div className="profile_details p-1">
                      <h4>{formData.name} <span className={`${profile && profile.isActive ? 'text-success' : 'text-danger'}`}>{profile && profile.isActive ? "Approved" : 'Pending'}</span> </h4>
                      <span className="mt-0 pt-0">Enrollment Number</span>
                      <p>{formData.reg_no}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between py-1 px-2">
              <div className="d-flex left">
                <div className="btn-group rounded" role="group" aria-label="Basic example">
                  <button
                    type="button"
                    className={`py-2 px-3 rounded-start ${activeStatus === 0 && 'active'}`}
                    onClick={() => setActiveStatus(0)}
                  >
                    Contact Details
                  </button>
                  <button
                    type="button"
                    className={`py-2 px-3 rounded-start ${activeStatus === 1 && 'active'}`}
                    onClick={() => setActiveStatus(1)}
                  >
                    Focal Persons
                  </button>
                  <button
                    type="button"
                    className={`py-2 px-3 rounded-start ${activeStatus === 2 && 'active'}`}
                    onClick={() => setActiveStatus(2)}
                  >
                    Social Links
                  </button>
                  <button
                    type="button"
                    className={`py-2 px-3 rounded-end ${activeStatus === 3 && 'active'}`}
                    onClick={() => setActiveStatus(3)}
                  >
                    Document Management
                  </button>
                </div>
              </div>
              {/* <div className="right">
                {(!newFocalPerson && activeStatus === 1) &&
                  <button className='add_new_btn px-2 py-1' onClick={() => setNewFocalPerson(true)}>Add new</button>
                }
                {(!newLink && activeStatus === 2) &&
                  <button className='add_new_btn px-2 py-1' onClick={() => setNewLink(true)}>Add new</button>
                }
                {(!newDoc && activeStatus === 3) &&
                  <button className='add_new_btn px-2 py-1' onClick={() => setNewDoc(true)}>Add new</button>
                }
              </div> */}
            </div>
          </div>
          {activeStatus === 0 && (
            <div className="col-md-12 data_table p-2 pt-1 pb-3 mt-3 my-auto mx-auto new_package">
              <div className="row  px-3 mt-3">
                <div className="d-flex justify-content-between px-1 info_header">
                  <div className="left">
                    <h4 className="mb-3">Personal Information</h4>
                  </div>
                </div>
                <hr />
              </div>
              <div className="row mt-3 mb-1 px-3">

                <div className="col-md-3 px-1 my-2">
                  <label htmlFor="name"className='required'>Agency Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Name here"
                  />
                </div>
                <div className="col-md-3 px-1 my-2">
                  <label htmlFor="reg_no"className='required'>Agency Registration No</label>
                  <input
                    type="text"
                    name="reg_no"
                    value={formData.reg_no}
                    onChange={handleChange}
                    placeholder="Registration No"
                  />
                </div>
                <div className="col-md-3 px-1 my-2">
                  <label htmlFor="address" className='required'>Agency Address</label>
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Address"
                  />
                </div>
                <div className="col-md-3 px-1 my-2">
                  <label htmlFor="profile_pic">Profile</label>
                  <input
                    type="file"
                    accept="image/*"
                    name="profile_pic"

                    onChange={handleImage}

                  />
                </div>
              </div>
              <hr />

              <div className="row mt-3 mb-1 px-3">
                <h5 className="mb-2">Contact Informations</h5>
                <div className="col-md-3 px-1 my-2">
                  <label htmlFor="email" className='required'>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email here"
                    readOnly
                  />
                </div>
                <div className="col-md-3 px-1 my-2">
                  <label htmlFor="phone" className='required'>Phone Number</label>
                  <input
                    type="number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone here"
                  />
                </div>
                <div className="col-md-3 px-1 my-2">
                  <label htmlFor="additional_phone">Additional Phone</label>
                  <input
                    type="number"
                    name="additional_phone"
                    value={formData.additional_phone}
                    onChange={handleChange}
                    placeholder="Additional Phone"
                  />
                </div>
                <div className="col-md-3 px-1 my-2">
                  <label htmlFor="whatsapp_phone">WhatsApp Number</label>
                  <input
                    type="number"
                    name="whatsapp_phone"
                    value={formData.whatsapp_phone}
                    onChange={handleChange}
                    placeholder="WhatsApp Number"
                  />
                </div>

                <div className="col-md-3 px-1 my-2">
                  <label htmlFor="munazam_name" className='required'>Munazzam Name</label>
                  <input
                    type="text"
                    name="munazam_name"
                    value={formData.munazam_name}
                    onChange={handleChange}
                    placeholder="Munazzam Name"
                  />
                </div>

                <div className="col-md-3 px-1 my-2">
                  <label htmlFor="province" className="required">Province</label>
                  <select
                    name="province"
                    value={formData.province}
                    onChange={handleProvinceChange}
                    required
                  >
                    <option value="">Select</option>
                    {provinceOptions.map((province) => (
                      <option key={province} value={province}>{province}</option>
                    ))}
                  </select>
                </div>

                <div className="col-md-3 px-1 my-2">
                  <label htmlFor="district" className="required">District/City</label>
                  <select
                    name="district"
                    value={formData.district}
                    onChange={handleDistrictChange}
                    required
                  >
                    <option value="">Select</option>
                    {districtOptions.map((district) => (
                      <option key={district} value={district}>{district}</option>
                    ))}
                  </select>
                </div>

              </div>
              <hr />

              {/* Navigation Buttons */}
              <div className="d-flex justify-content-end mt-4 px-3">
                <button className="px-3 py-2 save_btn" onClick={() => updateProfile()}>Update</button>
              </div>
            </div>
          )}

          {activeStatus === 1 &&
            <div className='col-md-12 focal_persons px-1 mb-2'>
      {!newFocalPerson &&
                <div className="col-md-12 profile mt-2 px-0">
                  <button className='add_new_btn px-2 py-1' onClick={() => setNewFocalPerson(true)}>Add new</button>
                </div>
              }
              <div className="row mt-3 px-0">
                {focal_persons && focal_persons.map((data, index) => (
                  <div className="col-md-3">
                    <div className="person_card shadow-sm bg-white rounded pb-4 pt-1">

                      <div className="actions text-end pt-0">
                        <div className="btn-group pt-0" role="group" aria-label="Basic example">
                          <button onClick={() => handleEdiePerson(data)} >
                            <svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10.0403 1.85156H8.35113C4.12815 1.85156 2.43896 3.54075 2.43896 7.76373V12.8313C2.43896 17.0543 4.12815 18.7435 8.35113 18.7435H13.4187C17.6417 18.7435 19.3309 17.0543 19.3309 12.8313V11.1421" stroke="#08A5DC" stroke-width="1.52027" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M14.2974 2.71332L7.642 9.36873C7.38862 9.62211 7.13524 10.1204 7.08457 10.4836L6.72139 13.0258C6.58626 13.9464 7.2366 14.5883 8.1572 14.4616L10.6994 14.0985C11.0542 14.0478 11.5525 13.7944 11.8143 13.541L18.4697 6.88562C19.6184 5.73697 20.1589 4.40251 18.4697 2.71332C16.7805 1.02413 15.4461 1.56467 14.2974 2.71332Z" stroke="#08A5DC" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M13.3428 3.66797C13.9087 5.68655 15.488 7.26594 17.5151 7.84027" stroke="#08A5DC" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </button>
                          <button onClick={() => deleteFocalPerson(data._id)}>
                            <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M16.6523 4.80811L16.1289 13.2752C15.9952 15.4386 15.9283 16.5202 15.3861 17.2979C15.118 17.6823 14.7728 18.0068 14.3725 18.2507C13.5629 18.7439 12.4792 18.7439 10.3117 18.7439C8.14144 18.7439 7.05629 18.7439 6.24611 18.2498C5.84556 18.0055 5.50029 17.6804 5.23229 17.2953C4.69022 16.5164 4.62483 15.4332 4.49405 13.2668L3.9834 4.80811" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                              <path d="M2.71631 4.80764H17.919M13.7431 4.80764L13.1665 3.61822C12.7835 2.82813 12.592 2.43308 12.2617 2.1867C12.1884 2.13205 12.1108 2.08344 12.0297 2.04134C11.6639 1.85156 11.2249 1.85156 10.3468 1.85156C9.44674 1.85156 8.9967 1.85156 8.62482 2.0493C8.54241 2.09312 8.46376 2.1437 8.3897 2.20052C8.05553 2.45688 7.86887 2.86639 7.49554 3.6854L6.98398 4.80764" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                              <path d="M8.20605 14.0981L8.20605 9.03058" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                              <path d="M12.4292 14.0983L12.4292 9.03076" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                            </svg>
                          </button>
                        </div>
                      </div>


                      <div className="image mx-auto pt-2 rounded-circle">
                        <Avatar className="mx-auto avatar" sx={{ height: 60, width: 60 }}>{data.name.slice(0, 1)}</Avatar>
                      </div>
                      <div className="text-center mt-3">
                        <h6 className="person-name">{data.name}</h6>
                        <p className="person-info">Email: {data.email}</p>
                        <p className="person-info">Phone: {data.phone}</p>
                        <p className="person-info">City: {data.city}</p>
                      </div>

                    </div>
                  </div>
                ))}

              </div>


              

            </div>

          }


          {activeStatus === 2 &&
            <div className='col-md-12 documents'>
            {newLink &&
                <div className='row'>
                  <div className="col-md-12 data_table py-3 px-2 mt-2 mb-1 my-auto mx-auto new_package">
                    <form onSubmit={addSocialLink}>
                      <div className="row">
                        <div className={`${isOtherPlatform ? "col-md-3" : "col-md-6"} my-auto`}>
                          <select name="" id="" value={platform} onChange={(e) => setplatform(e.target.value)} required>
                            <option value="">Social Platform</option>
                            <option value="Facebook">Facebook</option>
                            <option value="YouTube">YouTube</option>
                            <option value="Instagram">Instagram</option>
                            <option value="TikTok">TikTok</option>
                            <option value="Twitter(X)">Twitter(X)</option>
                            <option value=" Email Address">Email Address</option>
                            <option value="Website">Website</option>
                            <option value="WhatsApp">WhatsApp</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                        {isOtherPlatform && (
                        <div className="col-md-3 my-auto">
                          <input
                            type="text"
                            placeholder="Enter platform name"
                            value={platform1}
                            onChange={(e) => setplatform1(e.target.value)}
                            required
                          />
                        </div>
                      )}
                        <div className="col-md-6 my-auto">
                          <input type="text" placeholder='Enter Socila Platform Link' value={link} onChange={(e) => setlink(e.target.value)} required />


                        </div>
                        <div className="col-md-12 d-flex justify-content-between mt-3">
                          <button className="btn cancel_btn mx-2 py-2" type='button' onClick={() => hanldeCancelNewLink()}>Cancel</button>
                          <button className="btn save_btn mx-2 " type='submit'  >Save</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              }
            {(!newLink && activeStatus === 2) &&
            <div className='col-md-12 mx-0 profile mt-2 px-0'>
                  <button className='add_new_btn px-2 py-1' onClick={() => setNewLink(true)}>Add new</button>
            </div>
                }
              <div className="row mt-3">
                {social_links && social_links.filter(d => !d.isDeleted).map((data, index) => (
                  <div className='col-md-12 d-flex justify-content-between my-1 new_package data_table px-3 py-2 ' key={index} >
                    <div className="left my-auto">
                      <h6 className='my-auto'>{data.platform}</h6>
                    </div>
                    <div className="right my-auto d-flex justify-content-between file_details py-2 px-2">

                      <div className="left d-flex my-auto me-5">

                        <a className='my-auto' href={data.link} target='_blank' rel='noreferrer'>{data.link}</a>
                      </div>
                      <div className="right my-auto d-flex ms-5">
                        <div className="btn-group" role="group" aria-label="Basic example">
                          <button onClick={() => deleteSocialLink(data._id)}>
                            <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M16.6523 4.80811L16.1289 13.2752C15.9952 15.4386 15.9283 16.5202 15.3861 17.2979C15.118 17.6823 14.7728 18.0068 14.3725 18.2507C13.5629 18.7439 12.4792 18.7439 10.3117 18.7439C8.14144 18.7439 7.05629 18.7439 6.24611 18.2498C5.84556 18.0055 5.50029 17.6804 5.23229 17.2953C4.69022 16.5164 4.62483 15.4332 4.49405 13.2668L3.9834 4.80811" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                              <path d="M2.71631 4.80764H17.919M13.7431 4.80764L13.1665 3.61822C12.7835 2.82813 12.592 2.43308 12.2617 2.1867C12.1884 2.13205 12.1108 2.08344 12.0297 2.04134C11.6639 1.85156 11.2249 1.85156 10.3468 1.85156C9.44674 1.85156 8.9967 1.85156 8.62482 2.0493C8.54241 2.09312 8.46376 2.1437 8.3897 2.20052C8.05553 2.45688 7.86887 2.86639 7.49554 3.6854L6.98398 4.80764" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                              <path d="M8.20605 14.0981L8.20605 9.03058" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                              <path d="M12.4292 14.0983L12.4292 9.03076" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                            </svg>
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                ))}
              </div>  
            </div>

          }
          {activeStatus === 3 &&
            <div className='col-md-12 documents'>
              {newDoc &&
                <div className='row'>
                  <div className="col-md-12 data_table py-3 px-2 mt-2 mb-1 my-auto mx-auto new_package">
                    <form onSubmit={editedDocId ? updateFile : uploadFile}>
                      <div className="row">
                      <div className={`${isOtherFileName ? "col-md-3" : "col-md-6"} my-auto`}>
                        <select
                          name=""
                          id=""
                          value={file_name}
                          onChange={(e) => setfile_name(e.target.value)}
                          required
                        >
                          <option value="">Select</option>
                          <option value="Recognition Letter">Recognition Letter</option>
                          <option value="SECP Certificate">SECP Certificate</option>
                          <option value="Munazim Card">Munazim Card</option>
                          <option value='Other'>Other</option>
                        </select>
                      </div>

                      {/* Conditionally show the input for custom file name */}
                      {isOtherFileName && (
                        <div className="col-md-3 my-auto">
                          <input
                            type="text"
                            placeholder="Enter file name"
                            value={file_name2}
                            onChange={(e) => setfile_name2(e.target.value)}
                            required
                          />
                        </div>
                      )}
                        <div className="col-md-6 my-auto">
                          {!file_url ? (
                            <label htmlFor="file-upload" className="custom-file-upload d-flex flex-column align-items-center my-auto">
                              <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                {/* Add your SVG content here */}
                              </svg>
                              <h6 className="mt-2">
                                Drag and drop or
                                <p className="text-muted">or drag and drop PDF, JPG, PNG (max. 5MB)</p>
                              </h6>
                              <input
                                id="file-upload"
                                type="file"
                                accept=".pdf,.jpg,.jpeg,.png"
                                style={{ display: 'none' }}
                                onChange={handleFile}

                              />
                            </label>
                          ) : (
                            <div className="selected-file d-flex flex-column align-items-center">
                              <p
                                className="file-name text-primary"
                                style={{
                                  cursor: 'pointer',
                                  textDecoration: 'underline',
                                  color: '#007BFF',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  padding: '5px 10px',
                                  borderRadius: '5px',
                                  transition: 'all 0.3s',
                                  backgroundColor: '#F0F8FF',
                                }}
                                onClick={() => document.getElementById('selected-file-upload').click()}
                              >
                                {selected_file_name}
                              </p>
                              <input
                                id="selected-file-upload"
                                type="file"
                                accept=".pdf,.doc,.docx"
                                style={{ display: 'none' }}
                                onChange={handleFile}

                              />
                              <button
                                className="btn remove-btn mt-0"
                                onClick={clearFile}
                                style={{
                                  color: 'white',
                                  backgroundColor: '#FF4D4F',
                                  border: 'none',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  padding: '8px 15px',
                                  borderRadius: '8px',
                                  cursor: 'pointer',
                                  transition: 'background-color 0.3s ease',
                                }}
                                onMouseEnter={(e) => (e.target.style.backgroundColor = '#FF7875')}
                                onMouseLeave={(e) => (e.target.style.backgroundColor = '#FF4D4F')}
                              >
                                Remove File
                              </button>
                            </div>
                          )}

                        </div>
                        <div className="col-md-12 d-flex justify-content-between mt-3">
                          <button className="btn cancel_btn mx-2 py-2" type='button' onClick={() => handleCancel()}>Cancel</button>
                          <button className="btn save_btn mx-2 " type='submit'  >Save</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              }
           {!newDoc &&
                <div className="col-md-12 mx-0 profile mt-2 px-0">
                  <button className='add_new_btn px-2 py-1' onClick={() => setNewDoc(true)}>Add new</button>
                </div>
              }
              <div className="row mt-3">
                {documents && documents.filter(d => !d.isDeleted).map((data, index) => (
                  <div className='col-md-12 d-flex justify-content-between my-1 new_package data_table px-3 py-2 ' key={index} >
                    <div className="left my-auto">
                      <h6 className='my-auto'>{data.file_name}</h6>
                    </div>
                    <div className="right my-auto d-flex justify-content-between file_details py-2 px-2">

                      <div className="left d-flex my-auto me-5">
                        <img src={file_icon} alt="" className='my-auto' />
                        <p className='my-auto'>{data.selected_file_name}</p>
                      </div>
                      <div className="right my-auto d-flex ms-5">
                        <div className="btn-group" role="group" aria-label="Basic example">
                          <button onClick={() => handleEditDoc(data)}>
                            <svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10.0403 1.85156H8.35113C4.12815 1.85156 2.43896 3.54075 2.43896 7.76373V12.8313C2.43896 17.0543 4.12815 18.7435 8.35113 18.7435H13.4187C17.6417 18.7435 19.3309 17.0543 19.3309 12.8313V11.1421" stroke="#08A5DC" stroke-width="1.52027" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M14.2974 2.71332L7.642 9.36873C7.38862 9.62211 7.13524 10.1204 7.08457 10.4836L6.72139 13.0258C6.58626 13.9464 7.2366 14.5883 8.1572 14.4616L10.6994 14.0985C11.0542 14.0478 11.5525 13.7944 11.8143 13.541L18.4697 6.88562C19.6184 5.73697 20.1589 4.40251 18.4697 2.71332C16.7805 1.02413 15.4461 1.56467 14.2974 2.71332Z" stroke="#08A5DC" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M13.3428 3.66797C13.9087 5.68655 15.488 7.26594 17.5151 7.84027" stroke="#08A5DC" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </button>

                          <button onClick={() => {
                            if (data.file_url) {
                              window.open(data.file_url, '_blank');
                            } else {
                              console.error('File URL is not available');
                            }
                          }}>
                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M18.1959 9.4915C18.4527 9.85157 18.5811 10.0316 18.5811 10.2981C18.5811 10.5646 18.4527 10.7446 18.1959 11.1047C17.0422 12.7226 14.0956 16.2103 10.1352 16.2103C6.17466 16.2103 3.22814 12.7226 2.07438 11.1047C1.8176 10.7446 1.68921 10.5646 1.68921 10.2981C1.68921 10.0316 1.8176 9.85157 2.07438 9.4915C3.22814 7.87364 6.17466 4.38594 10.1352 4.38594C14.0956 4.38594 17.0422 7.87364 18.1959 9.4915Z" stroke="#6D76A1" stroke-width="1.52027" />
                              <path d="M12.6689 10.2981C12.6689 8.89872 11.5345 7.76431 10.1351 7.76431C8.73573 7.76431 7.60132 8.89872 7.60132 10.2981C7.60132 11.6975 8.73573 12.8319 10.1351 12.8319C11.5345 12.8319 12.6689 11.6975 12.6689 10.2981Z" stroke="#6D76A1" stroke-width="1.52027" />
                            </svg>
                          </button>

                          <button onClick={() => deleteFile(data._id)}>
                            <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M16.6523 4.80811L16.1289 13.2752C15.9952 15.4386 15.9283 16.5202 15.3861 17.2979C15.118 17.6823 14.7728 18.0068 14.3725 18.2507C13.5629 18.7439 12.4792 18.7439 10.3117 18.7439C8.14144 18.7439 7.05629 18.7439 6.24611 18.2498C5.84556 18.0055 5.50029 17.6804 5.23229 17.2953C4.69022 16.5164 4.62483 15.4332 4.49405 13.2668L3.9834 4.80811" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                              <path d="M2.71631 4.80764H17.919M13.7431 4.80764L13.1665 3.61822C12.7835 2.82813 12.592 2.43308 12.2617 2.1867C12.1884 2.13205 12.1108 2.08344 12.0297 2.04134C11.6639 1.85156 11.2249 1.85156 10.3468 1.85156C9.44674 1.85156 8.9967 1.85156 8.62482 2.0493C8.54241 2.09312 8.46376 2.1437 8.3897 2.20052C8.05553 2.45688 7.86887 2.86639 7.49554 3.6854L6.98398 4.80764" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                              <path d="M8.20605 14.0981L8.20605 9.03058" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                              <path d="M12.4292 14.0983L12.4292 9.03076" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                            </svg>
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                ))}
              </div>

           

              

              <div className="row">
                <div className="col-md-12 data_table py-2 px-3 mt-2 mb-1 my-auto mx-auto">
                  <p className='mt-2'>Following documents are required to verify your agency account:-</p>
                  <ul>
                    <li>Recognition Letter</li>
                    <li>SECP Certificate (Incorportaion Certificate)</li>
                    <li>Munazim Card</li>

                  </ul>
                </div>
              </div>
            </div>

          }

        </div>
      </div>


      {/* Adding a new focal person Modal/Dialog*/}
      <Dialog className='p-0'
        open={newFocalPerson}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="container-fluid">
          <div className="row ">
            <div className="col-md-12 px-0 m-0">
              <form onSubmit={editedPersonId ? updateFocalPerson : addFocalPerson}>
                <div className="card add_new_modal px-2">
                  <div className="card-header bg-white ">
                    {editedPersonId ? `Edit Focal Person` : `Add new focal person`}
                  </div>
                  <div className="card-body pt-0">
                    <div className="row  py-2">
                      <div className="col-md-12 mt-2 mb-3 justify-content-between d-flex">
                        {/* <div className="d-flex left">
                          <h5>Add focal person details below</h5>
                        </div> */}

                      </div>
                      <div className="data my-1 col-md-6 px-1">
                        <label htmlFor=""className='required' >Name</label>
                        <input type="text" value={name} 
                        placeholder="Name here"
                         onChange={(e) => setname(e.target.value)} className='mt-1' id="" required />
                      </div>
                      <div className="data my-1 col-md-6 px-1">
                        <label htmlFor="" className='required'>Email</label>
                        <input type="email" value={email} placeholder='Email here' onChange={(e) => setemail(e.target.value)} className='mt-1' id="" required />
                      </div>
                      <div className="data my-1 col-md-6 px-1">
                        <label htmlFor="" className='required'>Phone</label>
                        <input type="text" value={phone} placeholder="Phone here" onChange={(e) => setphone(e.target.value)} className='mt-1' id="" required />
                      </div>
                      <div className="data my-1 col-md-6 px-1">
                        <label htmlFor="" className='required'>City</label>
                        <input type="text" value={city} placeholder='City here' onChange={(e) => setcity(e.target.value)} className='mt-1' id="" required />
                      </div>

                      <hr />
                      <div className="text-end mt-1 pb-0">
                        <button className="btn cancel_btn mx-2  py-2" type='button' onClick={() => handleCoseNewPerson()}>Cancel</button>
                        <button className="btn save_btn mx-2 " type='submit' disabled={loading1}>{loading1 ? "Saving" : "Save"}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
